import React, { Component } from 'react';
import { Button } from '../../atoms';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String[]} features
 * @prop {String} heading
 * @prop {String} price
 * @prop {String} term
 * @prop {String} [href]
 *
 * @augments {Component<Props>}
 */
export default class PriceCard extends Component {

	render () {
		const {
			buttonLabel,
			features = [],
			heading,
			href,
			price,
			term,
		} = this.props;

		return (
			<div className='PriceCard'>
				<h1>{heading}</h1>
				<hr />
				<h2>
					{price}
					{term ? <span>/{term}</span> : null}
				</h2>
				<ul>
					{features.map((feature) => <li key={feature}>{feature}</li>)}
				</ul>
				<Button className='PriceCard-button' href={href}>{buttonLabel}</Button>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/molecules/PriceCard/PriceCard.js